// 二次确认弹窗封装
function deleRows(prompt,title,callback,types){
    var _this=window.Vue
    _this.$confirm(prompt, title, {
        confirmButtonText: '确定',
        closeOnClickModal:false,
        showCancelButton:false,
        closeOnPressEscape:false,
        showClose:false,
        roundButton:true,
        type: types?types:'warning'
      }).then(() => {
        callback()
      });
}
export default {
    confirmation:function(prompt,title,callback,types){
        return deleRows(prompt,title,callback,types)
    }
}


// WEBPACK FOOTER //
// ./src/assets/script/tip.js